import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { IoAddOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { format } from 'date-fns';
import { useUser } from '../context/UserContext';
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { useCustomDialog } from '../context/DialogProvider';
import { toast } from 'react-toastify';
import { useSavedAnnouncementsCount } from '../context/SavedAnnouncementsCountContext';
import { RiDraftLine } from 'react-icons/ri';
import { FiEdit2 } from 'react-icons/fi';
import api from '../utils/api';
import { Megaphone, TentTree } from "lucide-react";

function Annoucements() {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);
  const baseUrl = process.env.REACT_APP_API_URL;
   const { currentUser } = useUser();
    const { alert, confirm } = useCustomDialog();
    const{ count, updateCount }=useSavedAnnouncementsCount();

  useEffect(() => {
    api.get(`/api/announcements/all`)
      .then(res => setAnnouncements(res.data))
      .catch(err => console.error("Failed to fetch announcements", err));
  }, []);

  useEffect(() => {
    const fetchSavedCount = async () => {
      try {
        const response = await api.get(`/api/announcements/unpublished/count`);
        updateCount(response.data);
      } catch (error) {
        console.error("Error fetching saved announcements count:", error);
      }
    };

    fetchSavedCount();
  }, [updateCount, baseUrl, currentUser, count]);


  const roleBasedNavigate = (announcement) => {
    if(currentUser?.role === "HR"){
        navigate(`/hr/events/detail/announcement/${announcement.id}`)
      } else {  
     navigate(`/employee/events/detail/announcement/${announcement.id}`)
    }
  }


   const onDelete = async (id) => {
    if (await confirm("Are you sure you want to delete this announcement?")) {
      api.delete(`/api/announcements/${id}`)
        .then(() => {
          toast.success("Announcement deleted successfully!");
          setAnnouncements(prev => prev.filter(ann => ann.id !== id));
        })
        .catch(err => {
          console.error("Failed to delete announcement", err);
          toast.error("Failed to delete announcement.");
        });
    }
  }

  return (
    <div className="sm:p-6 sm:mt-auto mt-8 am:mb-auto mb-20 w-full mx-auto">
      {/* Header */}
      <motion.div
        className="flex justify-between gap-3 mb-6 bg-blue-100 rounded-xl p-4 sm:p-5 shadow-sm border border-slate-200"
        transition={{ duration: 0.4, type: "spring" }}
      >
          <div className='flex items-center gap-4 text-xl xs:text-2xl font-bold truncate'>
                  <div className='p-2 rounded-xl bg-slate-700 text-slate-100'>< Megaphone className="text-2xl" /></div>
                 
                <h2 className="text-xl xs:text-2xl font-bold">Announcements</h2>
                </div>


     {currentUser?.role === "HR" && (
      <div className='flex items-center gap-4'>
      <motion.button
  onClick={() => navigate("/hr/events/saved/annoucements")}
  className="relative bg-gray-200 border-slate-600 text-black px-4 py-2 rounded-full hover:bg-gray-300 flex items-center gap-2"
  whileHover={{ scale: 1.02 }}
  whileTap={{ scale: 0.98 }}
>
  <RiDraftLine />
  <span className="relative sm:block hidden">
    
    Drafts
   
  </span>
   {count > 0 && (
      <span className="absolute -top-2 -right-3 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
        {count}
      </span>
    )}
</motion.button>


        <motion.button
          onClick={() => navigate("/hr/events/create/annoucement")}
          className="bg-slate-800 text-white px-4 py-2 rounded-full hover:bg-slate-700 flex items-center gap-2"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <FiEdit2 className="text-lg" />
          <span className='sm:block hidden'>Create Announcement</span>
        </motion.button>
        </div>
        )}
      </motion.div>

      {/* Announcement List */}
      <div className="grid gap-4">
        {announcements.map((announcement) => (
          <motion.div
  key={announcement.id}
 
  className="p-4 rounded-xl shadow-md bg-white border cursor-pointer hover:shadow-lg transition-shadow"
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.3 }}
>
  <div className='flex justify-between items-start'>
    <div 
    className='w-full'
     onClick={() => roleBasedNavigate(announcement)}
     >
  <h3 className="text-lg font-semibold">{announcement.title}</h3>
  <p className="text-sm text-gray-500">
    {
  format(
    new Date(
      new Date(announcement.createdAt).toLocaleString("en-US", {
        timeZone: "Asia/Kolkata",
      })
    ),
    "dd-MM-yyyy"
  )
}
  </p>
  </div>
    {currentUser?.role === "HR" && (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onDelete(announcement.id);
      }}
      className="p-2 rounded-lg text-red-600 hover:bg-red-50 transition"
      title="Delete Announcement"
    >
      <MdDeleteOutline size={22} />
    </button>
    )}
  </div>
</motion.div>
        ))}
        {announcements.length === 0 && (
  <motion.div
    className="flex flex-col items-center justify-center text-center text-gray-500 mt-12"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
  >
    <span className="text-5xl mb-4">📭</span>
    <h4 className="text-xl font-medium">No Announcements Found</h4>
    <p className="text-sm mt-1 text-gray-400">
      Stay tuned — we’ll let you know when something important comes up.
    </p>
  </motion.div>
)}

      </div>
    </div>
  );
}

export default Annoucements;
